<template> 
<div>
     <BaseModal
        :id="'static_project_modal'"
        :title="title"
        :message="message"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb_local"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
            <div class="row mb-0 no-gutters">
                    <div class="col-lg-12 mt-4">
                        <v-card>
                            <table class="table">
                                <thead>
                                    <th></th>
                                    <th scope="col" class="header-item" v-for="(header, i) in table_headers" :key="i" v-html="header.text"/>
                                </thead>
                                <tbody>
                                    <tr v-for="(project, i) in projects" :key="i">
                                        <td>
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" name="exampleRadios" :id="'exampleRadios' + i" :value="project.id" v-model="selected_project_id" style="margin-top: 0px">
                                            </div>
                                        </td>
                                        <td scope="col" v-for="(header, i) in table_headers" :key="i" style="padding-bottom: 2px;">
                                            <b v-if="header.style == 'bold'">{{project[header.value]}}</b>
                                            <p v-else>{{project[header.value]}}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>                      
                        </v-card>
                    </div>
                </div>
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
    <ValidationsModal
    :breadcrumb="breadcrumb_local"
    :validate_data="validate_data"
    />
        </div>
</template>

<script>

import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'
import ValidationsModal   from  '@/components/AssigmentsComponent/ProjectTemplate/ValidationsModal'
import Resources        from    './resources'
import { Notyf }        from    'notyf'
import 'notyf/notyf.min.css'; 
const notyf = new Notyf({
    duration: 8000,
});


export default {

    name:   'ProjectModal',
    props: [
        "title",
        "content_header",
        "rest_api",
        "notifications",
        "array_options",
        "breadcrumb",
        "projects",
        "selected_rooms",
        "rooms_to_parent"
    ],

    components:{
        Breadcrumb,
        BaseModal,
        CentralButtons,
        ValidationsModal
    },

    data(){
        return{
            notyf,
            breadcrumb_local: [...this.breadcrumb],
            message: 'Choose the project which you want to schedule the selected rooms',
            search: '',
            selected_project_id: null,
            validate_data: [],
            table_headers: !this.has_role('Employee') ? Resources.table_headers_projects : Resources.employee_table_headers_projects,
        }
    },

    methods:{
        async form_submit()
        {
            await this.$emit('returnedRoomsToParent', {})
            if(!this.rooms_to_parent?.checked_items?.length)
            {
                notyf.error('No rooms selected')
                return false
            }

            if(!this.selected_project_id || this.selected_project_id === null)
            {
                notyf.error('No project selected')
                return false
            }

            this.loader(true)

            let api_route = this.rest_api + '/' + this.selected_project_id

            const response = await this.patch(api_route, this.rooms_to_parent)

            this.$emit('reset_checkboxes', response)
            this.selected_project_id = null;

            window.$('#static_project_modal').modal('hide')
            
             if(response.data.status)
            {
                notyf.success('Success');
            } 
            else
            {
                this.validate_data = response.data.data
                window.$('#validations').modal('show')
            }
            this.loader()
        }

    },

    mounted(){
        this.breadcrumb_local[this.breadcrumb.length - 1].arrow =  "<span class='slash'>/</span>"
        this.breadcrumb_local.push({
            name: 'Projects Modal',
            arrow: "",
        })
    }
    
}
</script>